'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isExpired;

var _utils = require('../utils');

var _getEntry2 = require('./_get-entry');

var _getEntry3 = _interopRequireDefault(_getEntry2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isExpired(resource) {
    var entry = (0, _getEntry3.default)(resource);

    if (!entry || !(0, _utils.is)(entry.expires, 'number')) return false;

    return entry.expires <= Date.now();
}